import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import { RobotEnvironmentContext } from '../contexts/general/RobotEnvironmentContext';

export const usePageTracking = (options?: { prefix?: string }) => {
    const { googleAnalyticsCode } = useContext(RobotEnvironmentContext);
    const location = useLocation();

    const prefix = options?.prefix || '';

    useEffect(() => {
        const _window = window as any;

        if (_window && _window.gtag) {
            if (googleAnalyticsCode !== undefined) {
                console.log('GA: Legacy hit:', googleAnalyticsCode, prefix + location.pathname, _window.gtag);
                _window.gtag('config', googleAnalyticsCode, { page_path: prefix + location.pathname });
            } else {
                console.log('GA: Event hit:', prefix + location.pathname);
                _window?.gtag('event', 'page_view', {
                    page_title: prefix + location.pathname,
                    page_location: window.location.host + prefix + location.pathname,
                    page_path: prefix + location.pathname,
                });
            }
        }
    }, [location, googleAnalyticsCode]); // eslint-disable-line react-hooks/exhaustive-deps
};
